import { atom, useAtomValue } from "jotai";

import { errorApiAtom } from "@/states/error/atoms";
import type { ErrorApiUiState } from "@/states/error/types";

const errorApiUiStateAtom = atom<ErrorApiUiState>((get) => {
  const { error } = get(errorApiAtom);

  if (!error) {
    return {
      status: "NotError",
    };
  }

  if (error.status === 404) {
    return {
      status: "Error404",
      error: error,
    };
  }

  if (error.status >= 400 && error.status < 500) {
    return {
      status: "Error400",
      error: error,
    };
  }

  if (error.status >= 500 && error.status < 600) {
    return {
      status: "Error500",
      error: error,
    };
  }

  return {
    status: "NotError",
  };
});

export const useErrorApiUiState = (): ErrorApiUiState =>
  useAtomValue(errorApiUiStateAtom);
